import { Controller } from "@hotwired/stimulus"
import {
  createHereMap,
  detailBubble,
  disposeHereMap,
  singleBubble,
} from "../helpers/here_map_helpers"

// Bubble labels come in as a value rather than being written here, so no user-facing
// German lives outside config/locales.
export default class extends Controller {
  static targets = ["map"]
  static values = { labels: Object }

  connect() {
    createHereMap(this.mapTarget, { center: { lat: 51.1657, lng: 10.4515 }, zoom: 6 })
      .then(({ H, map, ui }) => this.setMarkers(H, map, ui))
      .catch((error) => console.error("HERE map failed to load", error))
  }

  // The status tabs swap this frame in and out; release the engine or every switch leaks a
  // WebGL context until the browser starts refusing new ones.
  disconnect() {
    disposeHereMap(this.map)
    this.map = null
  }

  setMarkers(H, map, ui) {
    this.map = map
    const sitesData = JSON.parse(this.element.dataset.sites)
    const showBubble = singleBubble(H, ui)

    sitesData.forEach((site) => {
      const position = { lat: parseFloat(site.latitude), lng: parseFloat(site.longitude) }
      const marker = new H.map.Marker(position)
      map.addObject(marker)

      marker.addEventListener("tap", () => {
        // Pan the marker into view but leave the zoom exactly where the user put it — an
        // automatic zoom jump on every click makes the map unusable.
        map.getViewModel().setLookAtData({ position }, true)
        showBubble(position, this.siteBubble(site))
      })
    })
  }

  siteBubble(site) {
    const labels = this.labelsValue

    return detailBubble(
      [
        [labels.site, site.name],
        [labels.address, site.address],
      ],
      { href: `/sites/${site.id}`, linkLabel: labels.link },
    )
  }
}
